import React from 'react'
import { ImpactReview } from '@scope/scope-one-ui/core';

const ImpactReviewWidget = ({ esgScore, loading }) => {
  const maxScore = 10;
  return (
    <ImpactReview value={esgScore?.toFixed(2)} range={maxScore} loading={loading} />
  )
}

export default ImpactReviewWidget;